// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import promiseFinally from 'promise.prototype.finally'

promiseFinally.shim()
